import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';
import moment from 'moment';

export default class RowItemTuDongBaoCao extends React.Component {

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <Link onClick={this.props.parent.viewUpdateCategory.bind(this.props.parent, this.props.item)}>
            {this.props.item.tenBaoCao}
          </Link>
        </td>
        <td>
          {this.props.item.ngayBatDauBC ? moment(this.props.item.ngayBatDauBC).format('DD/MM/YYYY') : ''}
        </td>
        <td>
          {this.props.item.ngayKetThucBC ? moment(this.props.item.ngayKetThucBC).format('DD/MM/YYYY') : ''}
        </td>
        <td>
          {this.props.item.namBaoCao}
        </td>
        <td>
          {this.props.item.donViGuiInfo ? this.props.item.donViGuiInfo.ten : ''}
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              (CheckPermission('THAMSO_SUA') && !this.props.item.daTuDongGui) &&
                <Link
                  className="itt-edit"
                  onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)}
                  >
                  Chỉnh sửa
                </Link>
            }
            {
              (CheckPermission('THAMSO_XOA') && !this.props.item.daTuDongGui) &&
                <DeleteDialog
                  title= {'Xoá danh mục'}
                  content= {'Bạn chắc chắn muốn xoá danh mục này?'}
                  redux={this.props.parent}
                  deleteId = {this.props.item.cauHinhBaoCaoId}
                />
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemTuDongBaoCao.jsx